import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const weeklyScheduleRouteStripDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.weekSchedule,
  componentType: LAYOUT_COMPONENT_TYPE.weeklyScheduleRouteStrip,
  registryBlockKey: REGISTRY_BLOCK.presentation.weeklyScheduleRouteStrip,
  displayOrder: 4,
  content: {
    sectionTitle: loc3('Wochenroute', 'Weekly route', 'Lịch tuần'),
    supporting: loc3(
      'Wo der Truck diese Woche hält.',
      'Where the truck stops this week.',
      'Xe dừng đâu tuần này.',
    ),
    schedule: loc3(
      'Di — Viktualienmarkt Süd\nMi — Werksviertel\nDo — Gärtnerplatz\nFr — Sendlinger Tor\nSa — Englischer Garten West',
      'Tue — Viktualienmarkt South\nWed — Werksviertel\nThu — Gärtnerplatz\nFri — Sendlinger Tor\nSat — English Garden West',
      'T3 — Viktualienmarkt Nam\nT4 — Werksviertel\nT5 — Gärtnerplatz\nT6 — Sendlinger Tor\nT7 — Vườn Anh phía Tây',
    ),
  },
  media: {},
};
